import React from 'react';
import clone from 'clone';
import classNames from 'classnames';
import './layout/allLayouts';
import 'imagesloaded';

const { findIndex, sortBy } = _;
const $ = jQuery;

class IsotopeBlock extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'IsotopeBlock';
    this.state = {
      'posts': this.props.previewData ? this.props.previewData.data : [],
      option: {
        sortBy: 'asc',
      },
    };
  }
  componentDidMount() {
    this.initIsotope();
  }
  componentWillReceiveProps(nextProps) {
    this.handleFilterBySearch(nextProps.previewOptions);
  }
  initIsotope() {
    // setTimeout(() =>
    $('.rq-isotope-grid').imagesLoaded( function() {
      IsotopeGrid = $('.rq-isotope-grid').isotope({
        itemSelector: '.rq-element-item',
        layoutMode: 'masonry',
        percentage: true,
      });
    });


    // , 0);
  }
  handleFilterBySearch(previewOptions) {
    const self = this;
    IsotopeGrid.isotope({ filter: function() {
      const postId = $(this).data('postid');
      const key = findIndex(previewOptions.data, { ID: postId });
      if (key !== -1) {
        return true;
      }
    } });
  }

  render() {
    const posts = this.state.posts;
    const { settingsData } = this.props;
    const allPosts = (item, index) => {
      const allTerms = item.terms[this.props.block.selectedTaxonomy];
      const isotopeColumn = this.props.block.isotope_column;
      let allTermsValue = null;
      if (allTerms !== undefined) {
        allTermsValue = allTerms.join(' ');
      }
      let view = 'grid';
      const indexLayout = findIndex(this.props.allLayout, { uid: this.props.block.uid });
      if (indexLayout !== -1) {
        if (this.props.allLayout[indexLayout].previewLayouts !== undefined) {
          this.ComponentName = ReactiveTemplates[this.props.allLayout[indexLayout].previewLayouts];
        } else {
          this.ComponentName = ReactiveTemplates.latestGridLayoutThree;
        }
      }
      let rqIsotopItemWidth = {
        width: '50%',
      };
      if (isotopeColumn === '1') {
        rqIsotopItemWidth = { width: '100%' };
      }
      if (isotopeColumn === '2') {
        rqIsotopItemWidth = { width: '50%' };
      }
      if (isotopeColumn === '3') {
        rqIsotopItemWidth = { width: '33.3%' };
      }
      if (isotopeColumn === '4') {
        rqIsotopItemWidth = { width: '25%' };
      }
      return (
        <div className={'rq-element-item ' + allTermsValue } style={ rqIsotopItemWidth } key={'isotopeElement-' + index} data-postid={item.ID} data-category={allTermsValue}>
          <div className="rq-isotop-img">
            {indexLayout !== -1 ? <this.ComponentName post={item} view={view} {...this.props}/> : ''}
          </div>
        </div>
      );
    };
    let sortingData = [];
    if ('sorting' in this.props.block) {
      sortingData = this.props.block.sorting;
    }
    const ifOpen = this.props.isToggle ? 'active ' + 'rq-grid-container' : '';
    const ThemeComponent = window.ReactiveTheme[settingsData.theme] !== undefined ? window.ReactiveTheme[settingsData.theme].bar : {};
    return (<div className={ifOpen}>
      {this.props.isToggle && <div>
      {settingsData !== undefined || settingsData !== null ? <ThemeComponent.isotopBar {...this.props}/> : ''}
          <div className="rq-grid-container">
            <div className="rq-isotope-row">
              <div className="rq-isotope-grid">
                {posts.map(allPosts)}
              </div>
            </div>
          </div>
        </div> }
      </div>
    );
  }
}

IsotopeBlock.propTypes = {
  'allLayout': React.PropTypes.array,
  'settingsData': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'previewData': React.PropTypes.object,
  'isToggle': React.PropTypes.bool,
};

export default IsotopeBlock;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/isotopeBlock.js
 **/